import { academic } from '../menu-items/superadmin/academic';

export const dashboardDict: {
  [key: string]: typeof academic.children;
} = {
  academic: academic.children,
};
